import vpsOciTypes from './vpsOci.types';

const getVpsOciRequest = hostingId => ({ type: vpsOciTypes.GET_VPS_OCI_REQUEST, payload: hostingId });
const setVpsOciData = data => ({ type: vpsOciTypes.SET_VPS_OCI_DATA, payload: data });
const setVpsOciLoading = loading => ({ type: vpsOciTypes.VPS_OCI_SET_LOADING, payload: loading });

const statusVpsOciRequest = hostingId => ({ type: vpsOciTypes.STATUS_VPS_OCI_REQUEST, payload: hostingId });
const setStatusVpsOciData = status => ({ type: vpsOciTypes.STATUS_VPS_OCI_DATA, payload: status });
const setStatusVpsOciLoading = loading => ({ type: vpsOciTypes.STATUS_VPS_OCI_LOADING, payload: loading });

const rebootVpsRequest = hostingId => ({ type: vpsOciTypes.REBOOT_VPS_REQUEST, payload: hostingId });
const setRebootVpsLoading = loading => ({ type: vpsOciTypes.REBOOT_VPS_SET_LOADING, payload: loading });

const rebuildVpsRequest = hostingId => ({ type: vpsOciTypes.REBUILD_VPS_REQUEST, payload: hostingId });
const setRebuildVpsLoading = loading => ({ type: vpsOciTypes.REBUILD_VPS_SET_LOADING, payload: loading });
const setRebuildVpsStatus = status => ({ type: vpsOciTypes.REBUILD_VPS_SET_STATUS, payload: status });
const resetRebuildVps = () => ({ type: vpsOciTypes.REBUILD_VPS_RESET });

const changeImageVpsRequest = data => ({ type: vpsOciTypes.CHANGE_IMAGE_VPS_REQUEST, payload: data });
const setChangeImageVpsLoading = loading => ({ type: vpsOciTypes.CHANGE_IMAGE_VPS_SET_LOADING, payload: loading });
const setChangeImageVpsStatus = status => ({ type: vpsOciTypes.CHANGE_IMAGE_VPS_SET_STATUS, payload: status });
const setChangeImageVpsOciData = data => ({ type: vpsOciTypes.CHANGE_IMAGE_VPS_SET_DATA, payload: data });
const resetChangeImageVps = () => ({ type: vpsOciTypes.CHANGE_IMAGE_VPS_RESET });

const saveSshPasswordRequest = (hostingId, password, confirmPassword) => ({
  type: vpsOciTypes.SAVE_SSH_PASSWORD_REQUEST,
  payload: { hostingId, password, confirmPassword },
});
const setSaveSshPasswordLoading = loading => ({
  type: vpsOciTypes.SAVE_SSH_PASSWORD_SET_LOADING,
  payload: loading,
});
const setSaveSshPasswordSuccess = success => ({
  type: vpsOciTypes.SAVE_SSH_PASSWORD_SET_SUCCESS,
  payload: success,
});

const openSshTerminalRequest = hostingId => ({
  type: vpsOciTypes.OPEN_SSH_TERMINAL_REQUEST,
  payload: { hostingId },
});
const setOpenSshTerminalLoading = loading => ({
  type: vpsOciTypes.OPEN_SSH_TERMINAL_SET_LOADING,
  payload: loading,
});
const setOpenSshTerminalData = data => ({
  type: vpsOciTypes.OPEN_SSH_TERMINAL_SET_DATA,
  payload: data,
});

const saveTourStepRequest = ({ step, hostingId, session }) => ({
  type: vpsOciTypes.SAVE_TOUR_STEP_REQUEST,
  payload: { step, hostingId, session },
});

const getTour = ({ hostingId }) => ({
  type: vpsOciTypes.GET_TOUR_REQUEST,
  payload: { hostingId },
});

const setTourData = payload => ({
  type: vpsOciTypes.SET_TOUR_DATA,
  payload,
});

const getListingUpgradeVpsOci = hostingId => ({
  type: vpsOciTypes.GET_LISTING_UPGRADE_VPS_OCI,
  payload: hostingId,
});

const setDataListingUpgradeVpsOci = data => ({
  type: vpsOciTypes.SET_DATA_LISTING_UPGRADE_VPS_OCI,
  payload: data,
});

const setLoadingListingUpgradeVpsOci = loading => ({
  type: vpsOciTypes.SET_LOADING_LISTING_UPGRADE_VPS_OCI,
  payload: loading,
});

const getDetailsUpgradeVpsOci = data => ({
  type: vpsOciTypes.GET_DETAILS_UPGRADE_VPS_OCI,
  payload: data,
});

const setDataDetailsUpgradeVpsOci = data => ({
  type: vpsOciTypes.SET_DATA_DETAILS_UPGRADE_VPS_OCI,
  payload: data,
});

const setLoadingDetailsUpgradeVpsOci = loading => ({
  type: vpsOciTypes.SET_LOADING_DETAILS_UPGRADE_VPS_OCI,
  payload: loading,
});

const upgradeVpsOci = (hostingId, data) => ({
  type: vpsOciTypes.UPGRADE_VPS_OCI,
  payload: { hostingId, data },
});

const setDataUpgradeVpsOci = data => ({
  type: vpsOciTypes.SET_DATA_UPGRADE_VPS_OCI,
  payload: data,
});

const setLoadingUpgradeVpsOci = loading => ({
  type: vpsOciTypes.SET_LOADING_UPGRADE_VPS_OCI,
  payload: loading,
});

const resetUpgradeVpsOci = () => ({
  type: vpsOciTypes.RESET_UPGRADE_VPS_OCI,
});

const saveTokenOpenClawRequest = (hostingId, data) => ({
  type: vpsOciTypes.SAVE_TOKEN_OPENCLAW_REQUEST,
  payload: { hostingId, data },
});

const setSaveTokenOpenClawLoading = loading => ({
  type: vpsOciTypes.SAVE_TOKEN_OPENCLAW_SET_LOADING,
  payload: loading,
});

const setSaveTokenOpenClawSuccess = success => ({
  type: vpsOciTypes.SAVE_TOKEN_OPENCLAW_SET_SUCCESS,
  payload: success,
});

const configureGatorClawRequest = hostingId => ({
  type: vpsOciTypes.CONFIGURE_GATORCLAW_REQUEST,
  payload: { hostingId },
});

const setConfigureGatorClawLoading = loading => ({
  type: vpsOciTypes.CONFIGURE_GATORCLAW_SET_LOADING,
  payload: loading,
});

const setConfigureGatorClawSuccess = success => ({
  type: vpsOciTypes.CONFIGURE_GATORCLAW_SET_SUCCESS,
  payload: success,
});

const fetchSshKeysRequest = hostingId => ({
  type: vpsOciTypes.FETCH_SSH_KEY_REQUEST,
  payload: { hostingId },
});

const fetchSshKeysLoading = loading => ({
  type: vpsOciTypes.FETCH_SSH_KEY_LOADING,
  payload: loading,
});

const fetchSshKeysSuccess = data => ({
  type: vpsOciTypes.FETCH_SSH_KEY_SUCCESS,
  payload: data,
});

const fetchSshKeysFailure = error => ({
  type: vpsOciTypes.FETCH_SSH_KEY_FAILURE,
  payload: error,
  error: true,
});

const fetchSshKeysReset = () => ({
  type: vpsOciTypes.FETCH_SSH_KEY_RESET,
});

const createSshKeyRequest = (hostingId, body) => ({
  type: vpsOciTypes.CREATE_SSH_KEY_REQUEST,
  payload: { hostingId, body },
});

const createSshKeyLoading = loading => ({
  type: vpsOciTypes.CREATE_SSH_KEY_LOADING,
  payload: loading,
});

const createSshKeySuccess = data => ({
  type: vpsOciTypes.CREATE_SSH_KEY_SUCCESS,
  payload: data,
});

const createSshKeyFailure = error => ({
  type: vpsOciTypes.CREATE_SSH_KEY_FAILURE,
  payload: error,
  error: true,
});

const deleteSshKeyRequest = (hostingId, body) => ({
  type: vpsOciTypes.DELETE_SSH_KEY_REQUEST,
  payload: { hostingId, body },
});

const deleteSshKeyLoading = loading => ({
  type: vpsOciTypes.DELETE_SSH_KEY_LOADING,
  payload: loading,
});

const deleteSshKeySuccess = keyId => ({
  type: vpsOciTypes.DELETE_SSH_KEY_SUCCESS,
  payload: keyId,
});

const deleteSshKeyFailure = error => ({
  type: vpsOciTypes.DELETE_SSH_KEY_FAILURE,
  payload: error,
  error: true,
});

const createSshKeyReset = () => ({
  type: vpsOciTypes.CREATE_SSH_KEY_RESET,
});

const deleteSshKeyReset = () => ({
  type: vpsOciTypes.DELETE_SSH_KEY_RESET,
});

const actions = {
  data: {
    get: getVpsOciRequest,
    set: setVpsOciData,
    loading: setVpsOciLoading,
  },
  status: {
    get: statusVpsOciRequest,
    set: setStatusVpsOciData,
    loading: setStatusVpsOciLoading,
  },
  reboot: {
    request: rebootVpsRequest,
    loading: setRebootVpsLoading,
  },
  rebuild: {
    request: rebuildVpsRequest,
    loading: setRebuildVpsLoading,
    status: setRebuildVpsStatus,
    reset: resetRebuildVps,
  },
  changeImage: {
    request: changeImageVpsRequest,
    loading: setChangeImageVpsLoading,
    status: setChangeImageVpsStatus,
    set: setChangeImageVpsOciData,
    reset: resetChangeImageVps,
  },
  saveSshPassword: {
    request: saveSshPasswordRequest,
    loading: setSaveSshPasswordLoading,
    success: setSaveSshPasswordSuccess,
  },
  openSshTerminal: {
    request: openSshTerminalRequest,
    loading: setOpenSshTerminalLoading,
    set: setOpenSshTerminalData,
  },
  tour: {
    saveStep: saveTourStepRequest,
    get: getTour,
    set: setTourData,
  },
  upgrade: {
    reset: resetUpgradeVpsOci,
    listing: {
      request: getListingUpgradeVpsOci,
      set: setDataListingUpgradeVpsOci,
      loading: setLoadingListingUpgradeVpsOci,
    },
    details: {
      request: getDetailsUpgradeVpsOci,
      set: setDataDetailsUpgradeVpsOci,
      loading: setLoadingDetailsUpgradeVpsOci,
    },
    submit: {
      request: upgradeVpsOci,
      set: setDataUpgradeVpsOci,
      loading: setLoadingUpgradeVpsOci,
    },
  },
  openClaw: {
    saveToken: saveTokenOpenClawRequest,
    loading: setSaveTokenOpenClawLoading,
    success: setSaveTokenOpenClawSuccess,
  },
  gatorClaw: {
    configure: configureGatorClawRequest,
    loading: setConfigureGatorClawLoading,
    success: setConfigureGatorClawSuccess,
  },
  sshKeys: {
    fetch: {
      request: fetchSshKeysRequest,
      success: fetchSshKeysSuccess,
      loading: fetchSshKeysLoading,
      error: fetchSshKeysFailure,
      reset: fetchSshKeysReset,
    },
    create: {
      request: createSshKeyRequest,
      success: createSshKeySuccess,
      loading: createSshKeyLoading,
      error: createSshKeyFailure,
      reset: createSshKeyReset,
    },
    delete: {
      request: deleteSshKeyRequest,
      success: deleteSshKeySuccess,
      loading: deleteSshKeyLoading,
      error: deleteSshKeyFailure,
      reset: deleteSshKeyReset,
    },
  },
};

export default actions;
